module.exports = __webpack_public_path__ + "img/icon_question_duo.caeec699.png";